import { baseApi } from './baseApi';

export const authApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    login: build.mutation({
      query: (body) => ({ url: '/auth/login', method: 'POST', body }),
      transformResponse: (resp) => resp.data,
    }),
    refresh: build.mutation({
      query: (body) => ({ url: '/auth/refresh', method: 'POST', body }),
      transformResponse: (resp) => resp.data,
    }),
    logout: build.mutation({
      query: (body) => ({ url: '/auth/logout', method: 'POST', body }),
    }),
    me: build.query({
      query: () => '/auth/me',
      transformResponse: (resp) => resp.data,
      providesTags: ['Auth'],
    }),
    changePassword: build.mutation({
      query: (body) => ({ url: '/auth/change-password', method: 'POST', body }),
    }),
  }),
});

export const {
  useLoginMutation,
  useRefreshMutation,
  useLogoutMutation,
  useMeQuery,
  useChangePasswordMutation,
} = authApi;
